// extracted by mini-css-extract-plugin
export default {"text-box":"text-box--g2nhMeY4Wn","textBox":"text-box--g2nhMeY4Wn"};